import { resolvePath, useLocation } from 'react-router';

import { Navigate } from '../Navigate';

export const NotFound = () => {
  const location = useLocation();

  return (
    <Navigate
      to={resolvePath('..', location.pathname).pathname}
      keepSearchParams
      replace
    />
  );
};
